import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const StickyScholarshipButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      // Mostrar después de 500px de scroll
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    // Scroll suave a la sección de admisiones
    const admissionsSection = document.getElementById('admissions');
    if (admissionsSection) {
      admissionsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`fixed bottom-8 right-8 z-50 
        bg-gradient-to-r from-[#D4AF37] to-[#F4E4B7] 
        text-black font-bold px-6 py-4 rounded-full 
        shadow-2xl hover:shadow-[#D4AF37]/50 
        transform transition-all duration-300 
        hover:scale-110 hover:-translate-y-1
        flex items-center gap-3 group
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}
    >
      <span className="text-2xl">🎓</span>
      <div className="flex flex-col items-start">
        <span className="text-sm leading-tight">Solicitar</span>
        <span className="text-base leading-tight font-extrabold">Beca Libertad</span>
      </div>
      <svg 
        className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" 
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
      </svg>
    </button>
  );
};

export default StickyScholarshipButton;
